export default "__VITE_ASSET__DNu0YHoq__"